import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { ModalHeaderModule } from '@sondermind/features/modal-header';
import { TherapistInitialsPipe, TherapistPhotoPipe } from '@sondermind/features/therapist-profile';

import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisCheckboxModule } from '@sondermind/iris/checkbox';
import { IrisFormFieldModule } from '@sondermind/iris/form-field';
import { IrisProgressBarModule } from '@sondermind/iris/progress-bar';
import { IrisTextAreaModule } from '@sondermind/iris/text-area';

import { FormlibModule } from '@sondermind/formlib';
import { IrisIconComponent } from '@sondermind/iris/icon';
import { SonderModalModule } from '@sondermind/core/design/sonder-modal/sonder-modal.module';
import { DesignModule } from '@sondermind/core/design.module';

import { PsychiatryModalComponent } from './psychiatry-modal.component';

@NgModule({
  imports: [
    CommonModule,
    DesignModule,
    FormsModule,
    ReactiveFormsModule,
    IrisFormFieldModule,
    IrisTextAreaModule,
    IrisButtonModule,
    IrisCheckboxModule,
    IrisIconComponent,
    IrisProgressBarModule,
    SonderModalModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSnackBarModule,
    TherapistInitialsPipe,
    TherapistPhotoPipe,
    ModalHeaderModule,
    FormlibModule
  ],
  declarations: [
    PsychiatryModalComponent,
  ],
  exports: [
    PsychiatryModalComponent
  ]
})
export class PsychiatryModalModule { }
